module.exports = __webpack_public_path__ + "media/images/icons/data-transfer-upload-b0643c4a944ae956e96aefffaa606885.svg";